// extracted by mini-css-extract-plugin
export default {"container":"RuleConfig_container__qoYzC","description":"RuleConfig_description__bZjUc","rule":"RuleConfig_rule__9b7kv"};